import { create } from "../../../common/utils/zustand_state_manager";
import { IEquipamentoMedicaoService } from "../../../features/equipamentoMedicoes/data/services/equipamentoMedicaoService";
import { EquipamentoMedicaoService } from "../../../features/equipamentoMedicoes/data/services/equipamentoMedicaoService_impl";

/**
 * useAdministracaoServices
 */

type State = {
  equipamentoMedicaoService: IEquipamentoMedicaoService,
};

export const useEquipamentoMedicaoServices = create<State>((set, get) => ({
  equipamentoMedicaoService: new EquipamentoMedicaoService(),
}));